/**
 * 전역적으로 키 입력 이벤트를 관리해주는 매니저입니다.
 */
import {KEY_CODE} from "../../../constants/keycodes";

class KeyManager {
    // 현재 눌러지고 있는 키 배열
    _keydown = {};

    constructor(el) {
        this._el = el;
    }

    get isPressedCTRL() {
        return !!this._keydown.CTRL;
    }

    get isPressedSHIFT() {
        return !!this._keydown.SHIFT;
    }

    register(el) {
        if (!el) return;
        el.addEventListener("keydown", e => {
            switch (e.keyCode) {
                case KEY_CODE.CTRL:
                case KEY_CODE.CMD:
                    this._keydown.CTRL = true;
                    break;
                case KEY_CODE.SHIFT:
                    this._keydown.SHIFT = true;
                    break;
                default: break;
            }
        });
        el.addEventListener("keyup", e => {
            switch (e.keyCode) {
                case KEY_CODE.CTRL:
                case KEY_CODE.CMD:
                    this._keydown.CTRL = false;
                    break;
                case KEY_CODE.SHIFT:
                    this._keydown.SHIFT = false;
                    break;
                default: break;
            }
        });
    }
}

export default KeyManager;